/**
 * Space permanently reserved at the top of the screen by the Desktop system bar
 * (`.river-systembar`). This is the single source of truth for that boundary —
 * every consumer that needs to know "how far down is it safe to render things"
 * (window placement/clamping, the floating Space Chat panel, its detached rect,
 * etc.) must read this instead of hardcoding the bar's height, since the bar's
 * actual height is responsive (28px normally, 46px under the mobile breakpoint —
 * see `.systembar` in `DesktopShell.module.scss`) and can also be 0 when the bar
 * is unmounted (e.g. not yet mounted on initial render).
 *
 * Deliberately dependency-free (no store imports) so lightweight, decoupled
 * modules — like `desktopChatStore.ts` — can use it without pulling in the
 * larger window-management module graph.
 */
export const getSystemBarInset = (): number => {
  try {
    const bar = document.querySelector('.river-systembar') as HTMLElement | null;
    return bar ? Math.round(bar.getBoundingClientRect().bottom) : 0;
  } catch {
    return 0;
  }
};
